module.exports = __webpack_public_path__ + "img/专题分类.af44b2dd.png";